import { Col, Row } from 'react-bootstrap'
import Dropdown from '../../../../../sharedComponent/Dropdown/Dropdown'
import ElectricIcon from '../../../../../../_metronic/images/electric-icon.png'
import { productFieldConfig } from './AddProduct.types'
import { billingMethodOptions } from '../AddProductUtils'
import { ratePlaceHolder } from '../../../../../../utils/GlobalConstants'

const ElectricProperty = ({
  utilityData,
  handleSelectedItem,
  formik,
  contractTypeData,
  unitData,
  preventScroll,
  restrictDecimal,
  isDynamicProducts,
}: any) => {

  const onChangeRestrictDecimal = (e: React.SyntheticEvent, fieldName: string) => {
    formik.setFieldValue(fieldName, restrictDecimal((e.target as HTMLInputElement).value))
  }

  const electricConfigs: productFieldConfig[] = [
    {
      fieldTitle: 'E_Utility',
      fieldName: 'utility',
      type: 'DROPDOWN',
      data: utilityData,
      isMandatory: true,
    },
    {
      fieldTitle: 'E_Contract Type',
      fieldName: 'contractType',
      type: 'DROPDOWN',
      data: contractTypeData,
      isMandatory: true,
    },
    {
      fieldTitle: 'E_Unit',
      fieldName: 'unit',
      type: 'DROPDOWN',
      data: unitData,
      isMandatory: true,
    },
    {
      fieldTitle: 'E_Rate',
      fieldName: 'rate',
      type: 'number',
      isMandatory: true,
      placeHolder: ratePlaceHolder,
      handleChange: onChangeRestrictDecimal,
    },
    {
      fieldTitle: 'E_Second Rate ($)',
      fieldName: 'secondRate',
      type: 'number',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter E_second rate',
    },
    {
      fieldTitle: 'E_Term',
      fieldName: 'term',
      type: 'number',
      isMandatory: false,
      placeHolder: 'Enter E_term',
    },
    {
      fieldTitle: 'E_Early Termination Fee ($)',
      fieldName: 'earlyTerminationFee',
      type: 'number',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter E_early termination fee',
    },
    {
      fieldTitle: 'E_Service Fee ($)',
      fieldName: 'serviceFee',
      type: 'number',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter E_service fee',
    },
    {
      fieldTitle: 'E_Adder ($)',
      type: 'number',
      fieldName: 'added',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter E_adder',
    },
    {
      fieldTitle: 'E_Deposit ($)',
      type: 'number',
      fieldName: 'deposit',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter E_deposit',
    },
    {
      fieldTitle: 'E_Product Code',
      type: 'text',
      fieldName: 'ecode',
      isMandatory: true,
      placeHolder: 'Enter E_product Code',
    },
    {
      fieldTitle: 'E_Billing Method',
      type: 'DROPDOWN',
      fieldName: 'ebillingMethod',
      isMandatory: true,
      data: billingMethodOptions,
    },
  ]
  const dynamicelectricConfigs: productFieldConfig[] = [
    {
      fieldTitle: 'E_Utility',
      fieldName: 'utility',
      type: 'DROPDOWN',
      data: utilityData,
      isMandatory: true,
    },
    {
      fieldTitle: 'E_Contract Type',
      fieldName: 'contractType',
      type: 'DROPDOWN',
      data: contractTypeData,
      isMandatory: true,
    },
    {
      fieldTitle: 'E_Unit',
      fieldName: 'unit',
      type: 'DROPDOWN',
      data: unitData,
      isMandatory: true,
    },
    {
      fieldTitle: ' Minimum E_Rate',
      fieldName: 'rateMinimum',
      type: 'number',
      isMandatory: true,
      placeHolder: ratePlaceHolder,
      handleChange: onChangeRestrictDecimal,
    },
    {
      fieldTitle: ' Maximum E_Rate',
      fieldName: 'rateMaximum',
      type: 'number',
      isMandatory: true,
      placeHolder: ratePlaceHolder,
      handleChange: onChangeRestrictDecimal,
    },
    {
      fieldTitle: 'E_Second Rate ($)',
      fieldName: 'secondRate',
      type: 'number',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter E_second rate',
    },
    {
      fieldTitle: 'Minimum E_Term',
      fieldName: 'termMinimum',
      type: 'number',
      isMandatory: true,
      placeHolder: 'Enter E_term',
    },
    {
      fieldTitle: 'Maximum E_Term',
      fieldName: 'termMaximum',
      type: 'number',
      isMandatory: true,
      placeHolder: 'Enter E_term',
    },
    {
      fieldTitle: 'E_Early Termination Fee ($)',
      fieldName: 'earlyTerminationFee',
      type: 'number',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter E_early termination fee',
    },
    {
      fieldTitle: 'E_Service Fee ($)',
      fieldName: 'serviceFee',
      type: 'number',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter E_service fee',
    },
    {
      fieldTitle: 'E_Adder ($)',
      type: 'number',
      fieldName: 'added',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter E_adder',
    },
    {
      fieldTitle: 'E_Deposit ($)',
      type: 'number',
      fieldName: 'deposit',
      isMandatory: false,
      handleChange: onChangeRestrictDecimal,
      placeHolder: 'Enter E_deposit',
    },
    {
      fieldTitle: 'E_Product Code',
      type: 'text',
      fieldName: 'ecode',
      isMandatory: true,
      placeHolder: 'Enter E_product Code',
    },
    {
      fieldTitle: 'E_Billing Method',
      type: 'DROPDOWN',
      fieldName: 'ebillingMethod',
      isMandatory: true,
      data: billingMethodOptions,
    },
  ]

  const electricProduct = isDynamicProducts ? dynamicelectricConfigs : electricConfigs
  return (
    <>
      <div className='fw-bold fs-6 mb-2' style={{ color: '#5E6278' }}>
        <img src={ElectricIcon} alt='electric-icon' />
        Electric Property
      </div>
      <div className='property electric-property p-5'>
        <Row className='d-flex align-items-start mt-5 no-gutters noPadding mb-5'>
          {electricProduct.map((value: productFieldConfig) => {
            const { fieldName, fieldTitle, type, data, handleChange, isMandatory, placeHolder } =
              value
            return type === 'DROPDOWN' ? (
              <Col className='mb-4' sm md lg={6}>
                <label className={`d-flex align-items-center mb-2 ${isMandatory && 'required'}`}>
                  <span className='fs-6 fw-semibold lh-23'>{fieldTitle}</span>
                </label>
                <Dropdown
                  fieldName={fieldName}
                  optionList={data}
                  handleSelectedItem={handleSelectedItem}
                  formik={formik}
                  className='bg-white'
                />
              </Col>
            ) : (
              <Col className='mb-4' sm md lg={6}>
                <label className={`d-flex align-items-center mb-2 ${isMandatory && 'required'}`}>
                  <span className='fs-6 fw-semibold lh-23'>{fieldTitle}</span>
                </label>
                <input
                  type={type}
                  className='form-control form-control-lg form-control-solid bg-white'
                  placeholder={placeHolder}
                  id={fieldName}
                  onWheel={(event: any) => {
                    event.target.blur()
                  }}
                  {...formik.getFieldProps(fieldName)}
                  onChange={(e) => {
                    return handleChange
                      ? handleChange(e, fieldName)
                      : formik.setFieldValue(fieldName, e.target.value)
                  }}
                />
                {formik.errors[fieldName] && formik.touched[fieldName] && (
                  <div className='fv-plugins-message-container'>
                    <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                      {formik.errors[fieldName]}
                    </div>
                  </div>
                )}
              </Col>
            )
          })}
        </Row>
      </div>
    </>
  )
}
export default ElectricProperty
